import React from 'react';
import { getPage } from '../dynamicImports';
import { NotFound } from './NotFound';
import { Layout } from './Common/Layout/Layout';
import { PAC_NAME } from '../lib/config';

export class Router extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      path: '/',
      page: 'index',
      pathinfo: [],
      args: {},
      comp: null,
    };
    this.updateRoute = this.updateRoute.bind(this);
  }

  updateRoute() {
    const url = new URL(document.location.href, 'http://localhost/');
    let path = url.pathname;
    let page = path.substr(1) || 'index';
    let parts = page.split(/\/+/);
    let pathinfo = [];
    let comp = null;
    while (comp === null && parts.length > 0) {
      page = parts.join('/').replace(/[^A-Za-z0-9/]/g, '-');
      comp = getPage(page);
      if (comp === null || comp === undefined) {
        parts.push('index');
        page = parts.join('/').replace(/[^A-Za-z0-9/]/g, '-');
        comp = getPage(page);
        parts.pop();
        if (comp === null || comp === undefined) {
          pathinfo.unshift(parts.pop());
        }
      }
    }
    const args = {};
    Array.from(url.searchParams.keys()).forEach(k => {
      args[k] = url.searchParams.get(k);
    });
    if (comp instanceof Promise) {
      comp = comp.then(x => this.setState({ comp: x }));
    }
    this.setState({ path, page, pathinfo, args, comp });
  }

  componentDidMount() {
    this.updateRoute();
    window.addEventListener('popstate', this.updateRoute, { passive: true });
    window.addEventListener('pushstate', this.updateRoute, { passive: true });
  }

  render() {
    const Comp = this.state.comp;
    console.debug('Comp = (%o) %o', typeof Comp, Comp);
    window.mainComponent = Comp;
    if (Comp === null || Comp === undefined) {
      document.title = 'Not Found';
      return (
        <Layout page={this.state.page}>
          <NotFound path={this.state.path} />
        </Layout>
      );
    }
    if (Comp instanceof Promise) {
      document.title = PAC_NAME;
      return (
        <Layout page={this.state.page}>
          <div>...</div>
        </Layout>
      );
    }
    if (Comp.title) {
      document.title = `${Comp.title}: ${PAC_NAME}`;
    } else {
      document.title = PAC_NAME;
    }
    if (typeof Comp !== 'function') {
      return (
        <Layout page={this.state.page}>
          <div className="error">
            <p>Oops. A unpaid volunteer programmer messed up.  This page is broken.</p>
          </div>
        </Layout>
      );
    }
    return (
      <Layout page={this.state.page}>
        <Comp pathinfo={this.state.pathinfo.join('/')} {...this.state.args} />
      </Layout>
    );
  }
}
